var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconFilledHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "xjz45vqdha"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v464H0V0h1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aofn5rmz7b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10a1.166 1.166 0 1 1 0 2.333H1.167a1.166 1.166 0 1 1 0-2.333H17.5zm0-5a1.166 1.166 0 1 1 0 2.333H1.167a1.166 1.166 0 1 1 0-2.333H17.5zm0-5a1.166 1.166 0 1 1 0 2.333H1.167a1.166 1.166 0 1 1 0-2.333H17.5z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xjz45vqdha)",
    transform: "translate(-1104 -30)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aofn5rmz7b)",
    transform: "translate(1105.167 33.667)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#004BB9",
    d: "M0 0h18.667v12.333H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconFilledHamburger);
export default __webpack_public_path__ + "static/media/atoms-icon-filled-hamburger.d0971bbe0b13258804ff461626546051.svg";
export { ForwardRef as ReactComponent };